const PredictCityCountry2 = async (
  text: string
): Promise<google.maps.places.AutocompletePrediction[]> =>
  new Promise((resolve, reject) => {
    if (!text) {
      return reject("Need valid text input");
    }

    // for use in things like GatsbyJS where the html is generated first
    if (typeof window === "undefined") {
      return reject("Need valid window object");
    }

    try {
      new window.google.maps.places.AutocompleteService().getPlacePredictions(
        {
          input: text,
          types: ["(cities)"],
        },
        (predictions, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            resolve(predictions || []);
          } else {
            reject(`Google Maps API error: ${status}`);
          }
        }
      );
    } catch (e) {
      reject(e);
    }
  });
export type CityCountryPrediction = {
  suggestion: string| undefined;
  placeId: string | undefined;
};

const PredictCityCountry = async (
  text: string
): Promise<CityCountryPrediction[]> => {
  const sessionToken = new google.maps.places.AutocompleteSessionToken();

  const request = {
    input: text,
    sessionToken,
    includedPrimaryTypes: ["locality"], // filter only cities
  };

  const { suggestions } =
    await google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(
      request
    );
  const array: CityCountryPrediction[] = [];

  suggestions.forEach((element) => {
    array.push({
      suggestion: element.placePrediction?.text.text,
      placeId: element.placePrediction?.placeId,
    });
  });
  return array;
};

async function getPlaceDetails(placeId: string) {
  // Use place ID to create a new Place instance.
  const place = new google.maps.places.Place({
    id: placeId,
  });

  // Call fetchFields, passing the needed data fields.
  return await place.fetchFields({
    fields: ["addressComponents"],
  });
}

export { PredictCityCountry, getPlaceDetails };
